import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import Loader from '@educator/Composite/QuestionCreation/Loader';
import ObjectiveQuestionView from '@cont/Quiz/RevampedTaking/Content/QuestionView';
import { Spacings } from '@styles/index';
import { mediaQuery } from '@cont/Quiz/constants';
import Navigation from '../Navigation/Navigation';
import useLanding from '../../Taking/Landing/useLanding';
import Header from '../Header';
import QuestionActions from '../Content/QuestionActions';

const Modals = Dynamic(() => import('../Modals'));

const Wrapper = styled.div`
  background-color: var(--color-base-0);
  height: calc(100vh - 72px);
  margin: 0 ${Spacings.SPACING_10B};
  display: grid;
  grid-template-columns: 1fr 272px;
  column-gap: ${Spacings.SPACING_4B};

  ${mediaQuery.aboveTablet} {
    margin: 0 ${Spacings.SPACING_16B};
    column-gap: ${Spacings.SPACING_16B};
  }

  ${mediaQuery.aboveLargeScreen} {
    max-width: 1520px;
    margin: auto;
    column-gap: 112px;
  }
`;

const TakingLanding = () => {
  const { hasFetchedQuizQuestions } = useLanding();

  if (!hasFetchedQuizQuestions) {
    return <Loader />;
  }

  const renderQuestionView = () => {
    return <ObjectiveQuestionView />;
  };

  return (
    <>
      <Header />
      <Wrapper>
        <div>
          {renderQuestionView()}
          <QuestionActions />
        </div>
        <Navigation />
      </Wrapper>
      <Modals />
    </>
  );
};

export default TakingLanding;
